module.exports = __webpack_public_path__ + "img/kt3.9498c12b.png";